import { createAlphanumericFormatter } from '../generators/index.js';
const DIGIT = 'digit';
const mask = /^[0-9]{0,}$/;
const DigitFormatter = createAlphanumericFormatter({
    invalidMessage: 'tws.formatter.digit.invalid',
    mask,
    name: DIGIT,
    validate: (value) => Boolean(value.length && value.match(mask)),
});
export { DIGIT, DigitFormatter, };
export default DigitFormatter;
//# sourceMappingURL=digit.js.map